module.exports = __webpack_public_path__ + "img/ZM.3a3c22b6.png";